import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';
import socket from 'config/socket';

import {
  GET_CUSTOMERS, ADD_CUSTOMER, UPDATE_CUSTOMER
} from 'redux/actionTypes';
import { incrementIDGen, incrementIDGenSocket, setNewSOCustomerId } from '.';
import { customer } from 'constants/idGenType';
import { standard } from 'constants/userAccountTypes';

export const getCustomers = () => (dispatch, getState) => {
  axiosClient
    .get('/api/customers', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_CUSTOMERS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addCustomer = (newCustomer, updateNewSO, userId) => (dispatch, getState) => {
  axiosClient
    .post('/api/customers', newCustomer, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: userId, field: customer }));
      // If the customer is created for a new SalesOrder, update the customerId.
      if(updateNewSO) dispatch(setNewSOCustomerId(res.data.id));
      dispatch({
        type: ADD_CUSTOMER,
        payload: res.data
      });
      // Socket will only emit for standard users.
      socket.emit('broadcast-request', {
        request: 'add-customer-broad',
        data: {
          newCustomer: res.data,
          idGenId: userId
        }
      });
    })
    .catch(err => console.log(err))
};

export const addCustomerSocket = ({ newCustomer, idGenId }) => (dispatch, getState) => {
  dispatch({
    type: ADD_CUSTOMER,
    payload: newCustomer
  });

  // Only update the admin IDGen if the current user is a standard user.
  if(getState().activeUserType === standard) dispatch(incrementIDGenSocket({ user: idGenId, field: customer }));  
};

export const updateCustomer = (updatedCustomer) => (dispatch, getState) => {
  axiosClient
    .patch('/api/customers', updatedCustomer, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_CUSTOMER,
        payload: res.data
      });
      // Socket will only emit for standard users.
      socket.emit('broadcast-request', {
        request: 'update-customer-broad',
        data: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateCustomerSocket = updatedCustomer => ({
  type: UPDATE_CUSTOMER,
  payload: updatedCustomer
});